import React from 'react'

import { connect } from 'react-redux'

import { store } from '../../store'

import { setImages, setImagesPreview} from '../../actions/create-action'

import { setWebsite } from '../../actions/website-action'

import { setUser } from '../../actions/user-action'

const mapStateToProps = (state) => {
  let images = state.images
  let user = state.user.user
  let website = state.website
  let imagesPreview = state.imagesPreview;
  return {
    user: user,
    images: images,
    website: website,
    imagesPreview: imagesPreview,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUser: (user) => dispatch(setUser(user)),
    onImages: (image) => dispatch(setImages(image)),
    onWebsite: (website) => dispatch(setWebsite(website)),
    onImagesPreview: (images) => dispatch(setImagesPreview(images)),
  }
}


const initialState = {
  success: false,
  error: false,
  imageUploaded: false,
  userData: {},
  updated: false
}
class Save extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState
  }
onUpdate = () => {
  let flag = false
  if(!flag)
  {
    if(store.getState().imagesPreview.length !== 0)
    {
      this.onImageUpload()
    }
    else
    {
      if(!this.state.imageUploaded)
      {
        this.setState({imageUploaded: true})
      }
    }
    if(this.state.imageUploaded)
    {
      this.onSave()
      if(!flag)
      flag = true
      this.setState({updated: true})
    }
  }
}
onImageUpload = () => {
  let imgUp = false
  if(!imgUp && !this.state.imageUploaded)
  {  
    let {user, website, imagesPreview, admin} = store.getState()
    const data = new FormData()
    let arr = store.getState().imagesPreview
    arr.forEach((item, i) =>
    {
      data.append(`file${[i]}`, item.file)
      data.append(`alt_name${[i]}`, item.alt_name)
      data.append(`img_url${[i]}`, item.img_url)
    })
    data.append('url', website.url)
    data.append('username', user.user.username)
    if(store.getState().admin.token !== null)
    {
      data.append('adminusername', admin.username)
      data.append('token', admin.token)
    }
    else
    {
      data.append('token', user.token)
    }
    fetch(`${process.env.REACT_APP_API}/upload`, {
      method: 'post',
      body: data
    })
    .then((response) => response.json())
    .then((body) => 
    {
      if(!this.state.imageUploaded) {
        this.setState({imageUploaded: true})
      }
      this.props.onImages(body.images)
      imgUp = true
    })
    .catch((error)=> this.setState({error: true}))
  }
}
onSave = () => {
  let {user, website, about, customization, activities, links, admin} = store.getState()
  let bodyData = null
  let bdata = 0
  if(this.state.imageUploaded)
  {
    if(this.state.userData !== user.user)
    {
      this.setState({userData: user.user})
    }
    if(admin.token === null)
    {
      bodyData = {
        user: {
        username: user.user.username,
        },
        token: user.token,
        website: {
        name: website.name,
        url: website.url,
        bio: website.bio,
        template: website.template
        },
        about: {
        content: about.content,
        rawcontent: about.rawcontent
        },
        links: store.getState().links,
        customization: customization.custom
      }
      bdata = 1
    }
    else
    {
      bodyData = {
          user: {
            username: user.user.username
          },
          admin: {
            username: admin.username
          },
          token: admin.token,
          website: {
            name: website.name,
            url: website.url,
            bio: website.bio,
            template: website.template
          },
          about: {
            content: about.content,
            rawcontent: about.rawcontent
          },
          links: store.getState().links,
          customization: customization.custom
      }
      bdata = 1
    }
    if(bdata)
    {
      fetch(`${process.env.REACT_APP_API}/create`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(bodyData)
      })
      .then((response)=> response.json())
      .then((data)=> {
        if(data.about)
        {
          this.setState({success: true})
          let arr = website.sites
          arr.map((value,i)=> {
            if(value.url === website.url) {
              arr[i].template = website.template
              this.props.onWebsite(arr)
              this.setState({error: false})
            }
          })
        }
        else
        {
            this.setState({error: true})
        }
      })
    }
  }
}
    render(props) {
      if(this.state.success || this.state.error)
      {  
        setTimeout(
          function() {
              this.props.onHighlight('')
          }
          .bind(this),
          2000
        )
      }
      if(this.state.success)
      {
        return (
        <div className="save">
        <div className="save_success">
        <span
        onClick={()=>this.props.onHighlight('')} href="#" className="close"/>
        Succesfully saved !
        </div>
        </div>)
      }
      else if(this.state.error)
      {
        return (<div className="save">
        <div className="save_error">
        <span
        onClick={()=>this.props.onHighlight('')} href="#" className="close"/>
        Error: Something went wrong
        </div>
        </div>)
      }
      else {
        if(!this.state.updated)
        {
          this.onUpdate()
        }
        return null
      }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Save)